var dividerStyle = 'select_dividerStyle__1txzx5j1';
var indicatorStyle = 'select_indicatorStyle__1txzx5j0';
var optionItemContentStyle = 'select_optionItemContentStyle__1txzx5j2';
var optionLegacyItemContentStyle = 'select_optionLegacyItemContentStyle__1txzx5j3';

export { dividerStyle, indicatorStyle, optionItemContentStyle, optionLegacyItemContentStyle };
//# sourceMappingURL=select.vanilla.mjs.map
